/**
 * Mounts svelte component to angular component
 *
 * @param {Object|function|Promise} component - Svelte Component or import() promise
 * @param {HTMLElement} targetElement - Element to attach Svelte component to
 * @param {function(): Object} propsProvider - Function providing values for Svelte component properties
 * @param {Object<string, function>} listeners - Object containing event names as keys and event handlers as values
 * @returns {{ $onChanges: function(): void, $onInit: function(): void, $onDestroy: function(): void }} Lifecycle hooks for managing the Svelte component
 */
export default function (component, targetElement, propsProvider = () => ({}), listeners = {}) {
  let svelteComponent;

  return {
    async $onInit() {
      try {
        const c = await component;
        const Component = c.default ? c.default : c;
        svelteComponent = new Component({
          target: targetElement,
          props: propsProvider()
        });

        Object.keys(listeners).forEach(event => svelteComponent.$on(event, listeners[event]));
      } catch(e){
        // eslint-disable-next-line no-console
        console.error('Component failed to load', e)
      }
    },

    $onChanges(){
      if(svelteComponent)
        svelteComponent.$set(propsProvider())
    },

    $onDestroy() {
      if(svelteComponent) {
        try {
          svelteComponent.$destroy();
          svelteComponent = null;
        } catch(ignoredError){
          // suppresses https://github.com/sveltejs/svelte/issues/4765
        }
      }
    },
  }
}
